export default __webpack_public_path__ + "static/media/Orthodontics.7201d1d9.png";